function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.498,24.004c-0.134,0-0.259-0.052-0.354-0.146c-0.131-0.131-0.179-0.323-0.124-0.501l2-6.5 c0.004-0.013,0.009-0.026,0.016-0.038c0.024-0.062,0.061-0.12,0.108-0.168L18.061,0.733c0.472-0.469,1.1-0.727,1.768-0.727 c0.668,0,1.295,0.258,1.766,0.726l1.673,1.673c0.974,0.975,0.974,2.56,0,3.535L7.351,21.857c-0.041,0.041-0.089,0.073-0.147,0.1 c-0.004,0.002-0.023,0.01-0.027,0.012c-0.001,0.001-0.016,0.007-0.031,0.012l-6.502,2.001C0.596,23.997,0.547,24.004,0.498,24.004z  M1.254,22.748l1.362-0.419l-0.943-0.943L1.254,22.748z M3.697,21.996l2.36-0.726l-0.413-0.413 c-0.094-0.094-0.146-0.22-0.146-0.354v-2h-2c-0.134,0-0.259-0.052-0.354-0.146l-0.413-0.413l-0.726,2.36L3.697,21.996z  M6.998,20.797L19.121,8.673L17.578,7.13L6.498,18.211v2.086L6.998,20.797z M5.791,17.504l11.08-11.081L15.328,4.88L3.205,17.004 l0.5,0.5H5.791z M19.828,7.966l0.793-0.793L16.828,3.38l-0.793,0.793L19.828,7.966z M21.328,6.466l1.233-1.233 c0.584-0.585,0.584-1.536,0-2.121L20.888,1.44c-0.282-0.28-0.659-0.434-1.06-0.434c-0.402,0-0.779,0.155-1.062,0.436l-1.231,1.231 L21.328,6.466z"
}));

function SvgPencil2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil2);
export default __webpack_public_path__ + "static/media/pencil-2.ac4ccc18.svg";
export { ForwardRef as ReactComponent };